export const Android = {
  TARGET_VERSION: '2.0.0',
  MIN_SUPPORTED_VERSION: '1.0.0',
  UNSUPPORTED_VERSION: 28,
};

export const iOS = {
  TARGET_VERSION: '2.0.0',
  MIN_SUPPORTED_VERSION: '1.0.0',
  UNSUPPORTED_VERSION: 15,
};
